import { render } from "./VistaVideoRealtorView.vue?vue&type=template&id=07c78852&ts=true"
import script from "./VistaVideoRealtorView.vue?vue&type=script&lang=ts"
export * from "./VistaVideoRealtorView.vue?vue&type=script&lang=ts"

import "./VistaVideoRealtorView.vue?vue&type=style&index=0&id=07c78852&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__